<script lang="ts"></script>

<script setup lang="ts">
/**
 * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [Stepper]
 * Статус обработки фотографий оператором
 */

// Hooks
import { computed } from "vue";

import CheckIcon from "@/ui/icons/check.vue";
import GearIcon from "@/ui/icons/gear.vue";
// Icons
import TimeIcon from "@/ui/icons/time.vue";

// Types
import type { I_Stepper } from "./stepper.types.js";

const props = defineProps<I_Stepper>();

const stepsActiveClass = computed(() => (activeStep: number) => {
    const steps: Record<I_Stepper["status"], number> = {
        WAITING: 1,
        GRADING: 2,
        PROCESSED: 3,
    };

    if (steps[props.status] >= activeStep) return "active";
    return "";
});
</script>

<template>
    <div data-component="stepper" class="tiw__stepper">
        <p class="tiw__stepper__status">
            {{ props.message }}
        </p>
        <div class="tiw__stepper__steps">
            <div class="tiw__stepper__step" :class="[`tiw__stepper__step_${stepsActiveClass(1)}`]">
                <TimeIcon />
            </div>
            <div
                class="tiw__stepper__divider"
                :class="[`tiw__stepper__divider_${stepsActiveClass(2)}`]"
            />
            <div class="tiw__stepper__step" :class="[`tiw__stepper__step_${stepsActiveClass(2)}`]">
                <GearIcon />
            </div>
            <div
                class="tiw__stepper__divider"
                :class="[`tiw__stepper__divider_${stepsActiveClass(3)}`]"
            />
            <div class="tiw__stepper__step" :class="[`tiw__stepper__step_${stepsActiveClass(3)}`]">
                <CheckIcon />
            </div>
        </div>
    </div>
</template>

<style lang="scss" src="./stepper.scss"></style>
